import { parseColor } from 'react-aria-components';

/** 解析阴影颜色字符串，拆分为 hex 与 alpha（供取色器 + 透明度滑条编辑） */
export function parseShadowColor(
  color: string,
  fallbackHex = '#6E6E6E',
): { hex: string; opacity: number } {
  const raw = color.trim();
  if (!raw) return { hex: fallbackHex, opacity: 1 };
  try {
    const parsed = parseColor(raw);
    return {
      hex: parsed.toString('hex').toUpperCase(),
      opacity: clamp01(parsed.getChannelValue('alpha') ?? 1),
    };
  } catch {
    return { hex: fallbackHex, opacity: 1 };
  }
}

/** 将 hex 与 0–1 透明度合成为 CSS 颜色（通常为 `rgba(...)`，供 box-shadow / canvas 使用） */
export function shadowColorToRgba(hex: string, opacity: number): string {
  const alpha = clamp01(opacity);
  try {
    return parseColor(hex).withChannelValue('alpha', alpha).toString('css');
  } catch {
    const rgb = parseShadowColor(hex, '#6E6E6E');
    try {
      return parseColor(rgb.hex).withChannelValue('alpha', alpha).toString('css');
    } catch {
      return `rgba(110, 110, 110, ${alpha})`;
    }
  }
}

function clamp01(n: number): number {
  return Math.min(1, Math.max(0, n));
}
